<fieldset class="border rounded-3 p-3">
  <legend class="subtitle-4 float-none w-auto px-3">
    External pressure only, loadings such as wind and earthquake are not
    considered.
  </legend>
  <div *ngIf="validationList.length > 0">
    <validation
      [ValidationList]="validationList"
      [ValidationLabel]="validationListLabel"
    ></validation>
    <br />
  </div>
  <div class="container">
    <form [formGroup]="maepForm">
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="selectedComponentType">Component type:</label>
        </div>
        <div class="col-sm-4">
          <select
            id="selectedComponentType"
            formControlName="selectedComponentType"
            class="form-control form-control-sm"
            name="selectedComponentType"
            (change)="onComponentTypeChange($event.target.value)"
          >
            <option value="-1">Select Type</option>
            <option
              *ngFor="let data of ComponentTypeData"
              [value]="data.value"
              [hidden]="data.value === '-1'"
            >
              {{ data.text }}
            </option>
          </select>
        </div>
      </div>
      <div>
     <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label
              class="float-left"
              for="textBox2_MAEP"
              *ngIf="[-1, 0, 1, 2].indexOf(componentMAEP.intEquip) !== -1"
              >Original Outside Diameter, Dₒ&nbsp;<span *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label>
          </div>
          <div class="col-sm-4">
            <input
              class="float-right"
              type="number"
              labelDisable
              appRestrictInput
              id="textBox2_MAEP"
              formControlName="textBox2_MAEP"
              name="textBox2_MAEP"
              class="form-control form-control-sm"
              (change)="textBox2_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox3_MAEP"
              >Original nominal thickness, tnom&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox3_MAEP"
              formControlName="textBox3_MAEP"
              name="textBox3_MAEP"
              class="form-control form-control-sm"
              (change)="textBox3_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox4_MAEP"
              >Current uniform metal loss (internal), LOSSi&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox4_MAEP"
              formControlName="textBox4_MAEP"
              name="textBox4_MAEP"
              class="form-control form-control-sm"
              (change)="textBox4_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox5_MAEP"
              >Current uniform metal loss (external), LOSSe&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox5_MAEP"
              formControlName="textBox5_MAEP"
              name="textBox5_MAEP"
              class="form-control form-control-sm"
              (change)="textBox5_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox6_MAEP"
              >Future corrosion allowance (internal), FCAi&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox6_MAEP"
              formControlName="textBox6_MAEP"
              name="textBox6_MAEP"
              class="form-control form-control-sm"
              (change)="textBox6_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox7_MAEP"
              >Future corrosion allowance (external), FCAe&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox7_MAEP"
              formControlName="textBox7_MAEP"
              name="textBox7_MAEP"
              class="form-control form-control-sm"
              (change)="textBox7_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox8_MAEP"
              >Equipment design external pressure or MAEP, Pe_d&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(psi)</span
              ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox8_MAEP"
              formControlName="textBox8_MAEP"
              name="textBox8_MAEP"
              class="form-control form-control-sm"
              (change)="textBox8_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox9_MAEP"
              >Unstiffened/unsupported length, L&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox9_MAEP"
              formControlName="textBox9_MAEP"
              name="textBox9_MAEP"
              class="form-control form-control-sm"
              (change)="textBox9_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
         <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox10_MAEP"
              >Minimum Specified Yield Strength at temperature, SMYS
              <span *ngIf="this.intUnit === 1">(MPa)</span> <span *ngIf="this.intUnit === 0">(psi)</span>:
              </label>
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox10_MAEP"
              formControlName="textBox10_MAEP"
              name="textBox10_MAEP"
              class="form-control form-control-sm"
              (change)="textBox10_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>


        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox11_MAEP"
              >Minimum Specified Tensile Strength at temperature, SMTS <span *ngIf="this.intUnit === 1">(MPa)</span> <span *ngIf="this.intUnit === 0">(psi)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox11_MAEP"
              formControlName="textBox11_MAEP"
              name="textBox11_MAEP"
              class="form-control form-control-sm"
              (change)="textBox11_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox12_MAEP"
              >Young's Modulus at temperature, Ey <span *ngIf="this.intUnit === 1">(MPa)</span> <span *ngIf="this.intUnit === 0">(psi)</span>:</label
            >
          </div>
          <div class="col-sm-4">
             <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox12_MAEP"
              formControlName="textBox12_MAEP"
              name="textBox12_MAEP"
              class="form-control form-control-sm"
              (change)="textBox12_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>

        
         <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="comboBox1_DI_EquipInfo">Material for stress-strain curve parameters (m₂ and ε_p):</label>
          </div>
          <div class="col-sm-4">
             <select
              id="comboBox1_DI_EquipInfo"
              class="form-control form-control-sm"
              (change)="onChangeComboBox1_DI_EquipInfo($event.target.value)"
              formControlName="comboBox1_DI_EquipInfo">
              <option *ngFor="let data of MaterialStressData" [value]="data.id">
                {{ data.text }}
              </option>
            </select>
                
          </div>
        </div>

        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox13_MAEP"
              >Allowable Remaining Strength Factor, RSFa (default = 0.9):</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              appRestrictInput
              id="textBox13_MAEP"
              formControlName="textBox13_MAEP"
              name="textBox13_MAEP"
              class="form-control form-control-sm"
              (change)="textBox13_MAEP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</fieldset>
